import { Fragment, ReactNode } from 'react';

export type PlaceholderProps = {
  component?: ReactNode;
  numberOfItems?: number;
};

/**
 * Display a number of the same items
 */ 
export const Placeholder = ({ component = <></>, numberOfItems = 1 }: PlaceholderProps) => {
  return (
    <>
      {Array(numberOfItems)
        .fill('')
        .map((_, key) => (
          <Fragment key={key}>{component}</Fragment>
        ))}
    </>
  );
};
